import axios from 'axios';

export default class RegisterService {
  public processRegistration(account: any): Promise<any> {
    return axios.post('/api/register', account);
  }

  public registerB2BCMSAdmin(account: any): Promise<any> {
    return axios.post('/api/register-b2b-cms-admin', account);
  }

  public registerCompanyAdministrator(account: any): Promise<any> {
    return axios.post('/api/register-company-administrator', account);
  }

  public registerNioEmployee(account: any): Promise<any> {
    return axios.post('/api/register-nio-employee', account);
  }
}
